import { History } from "history";

import { MediaDto } from "../../interfaces/media";
import {
  OlympicQuestionDto,
  CreateOlympicQuestionRequest,
  UpdateOlympicQuestionRequest,
  CreateUpdateOlympicRequest,
  OlympicDto,
  OlympicParticipantDto,
} from "../../interfaces/olympic";
import { PaginateQuery, Paginated } from "../../models";

//#region Get Questions by Olympic

export const GET_QUESTIONS_BY_OLYMPIC = "GET_QUESTIONS_BY_OLYMPIC";
export const GET_QUESTIONS_BY_OLYMPIC_SUCCESS: any =
  "GET_QUESTIONS_BY_OLYMPIC_SUCCESS";
export const GET_QUESTIONS_BY_OLYMPIC_ERROR: any =
  "GET_QUESTIONS_BY_OLYMPIC_ERROR";

export interface GetQuestionsByOlympicAction {
  type: typeof GET_QUESTIONS_BY_OLYMPIC;
  payload: { query: PaginateQuery };
}

export interface GetQuestionsByOlympicSuccessAction {
  type: typeof GET_QUESTIONS_BY_OLYMPIC_SUCCESS;
  payload: OlympicQuestionDto[];
}

export interface GetQuestionsByOlympicErrorAction {
  type: typeof GET_QUESTIONS_BY_OLYMPIC_ERROR;
  payload: any;
}

//#endregion

//#region Get Olympic Question

export const GET_OLYMPIC_QUESTION = "GET_OLYMPIC_QUESTION";
export const GET_OLYMPIC_QUESTION_SUCCESS: any = "GET_OLYMPIC_QUESTION_SUCCESS";
export const GET_OLYMPIC_QUESTION_ERROR: any = "GET_OLYMPIC_QUESTION_ERROR";

export interface GetOlympicQuestionAction {
  type: typeof GET_OLYMPIC_QUESTION;
  payload: {
    id: string;
    history: History;
  };
}

export interface GetOlympicQuestionSuccessAction {
  type: typeof GET_OLYMPIC_QUESTION_SUCCESS;
  payload: OlympicQuestionDto;
}

export interface GetOlympicQuestionErrorAction {
  type: typeof GET_OLYMPIC_QUESTION_ERROR;
  payload: any;
}
//#endregion

//#region Add Olympic Question

export const ADD_OLYMPIC_QUESTION = "ADD_OLYMPIC_QUESTION";
export const ADD_OLYMPIC_QUESTION_SUCCESS: any = "ADD_OLYMPIC_QUESTION_SUCCESS";
export const ADD_OLYMPIC_QUESTION_ERROR: any = "ADD_OLYMPIC_QUESTION_ERROR";

export interface AddOlympicQuestionAction {
  type: typeof ADD_OLYMPIC_QUESTION;
  payload: {
    request: CreateOlympicQuestionRequest;
    history: History;
  };
}

export interface AddOlympicQuestionSuccessAction {
  type: typeof ADD_OLYMPIC_QUESTION_SUCCESS;
  payload: null;
}

export interface AddOlympicQuestionErrorAction {
  type: typeof ADD_OLYMPIC_QUESTION_ERROR;
  payload: any;
}
//#endregion

//#region Update Olympic Question

export const UPDATE_OLYMPIC_QUESTION = "UPDATE_OLYMPIC_QUESTION";
export const UPDATE_OLYMPIC_QUESTION_SUCCESS: any =
  "UPDATE_OLYMPIC_QUESTION_SUCCESS";
export const UPDATE_OLYMPIC_QUESTION_ERROR: any =
  "UPDATE_OLYMPIC_QUESTION_ERROR";

export interface UpdateOlympicQuestionAction {
  type: typeof UPDATE_OLYMPIC_QUESTION;
  payload: {
    id: string;
    request: UpdateOlympicQuestionRequest;
    history: History;
  };
}

export interface UpdateOlympicQuestionSuccessAction {
  type: typeof UPDATE_OLYMPIC_QUESTION_SUCCESS;
  payload: null;
}

export interface UpdateOlympicQuestionErrorAction {
  type: typeof UPDATE_OLYMPIC_QUESTION_ERROR;
  payload: any;
}
//#endregion

//#region Delete Olympic Question

export const DELETE_OLYMPIC_QUESTION_CONSENT: any =
  "DELETE_OLYMPIC_QUESTION_CONSENT";
export const DELETE_OLYMPIC_QUESTION = "DELETE_OLYMPIC_QUESTION";
export const DELETE_OLYMPIC_QUESTION_SUCCESS: any =
  "DELETE_OLYMPIC_QUESTION_SUCCESS";
export const DELETE_OLYMPIC_QUESTION_ERROR: any =
  "DELETE_OLYMPIC_QUESTION_ERROR";

export interface DeleteOlympicQuestionConsentAction {
  type: typeof DELETE_OLYMPIC_QUESTION_CONSENT;
  payload: string;
}

export interface DeleteOlympicQuestionAction {
  type: typeof DELETE_OLYMPIC_QUESTION;
  payload: {
    id: string;
    history: History;
  };
}

export interface DeleteOlympicQuestionSuccessAction {
  type: typeof DELETE_OLYMPIC_QUESTION_SUCCESS;
  payload: null;
}

export interface DeleteOlympicQuestionErrorAction {
  type: typeof DELETE_OLYMPIC_QUESTION_ERROR;
  payload: any;
}
//#endregion

//#region Upload Olympic Question Home Image

export const UPLOAD_OLYMPIC_QUESTION_DISPLAY_IMAGE =
  "UPLOAD_OLYMPIC_QUESTION_DISPLAY_IMAGE";
export const UPLOAD_OLYMPIC_QUESTION_DISPLAY_IMAGE_SUCCESS: any =
  "UPLOAD_OLYMPIC_QUESTION_DISPLAY_IMAGE_SUCCESS";
export const UPLOAD_OLYMPIC_QUESTION_DISPLAY_IMAGE_ERROR: any =
  "UPLOAD_OLYMPIC_QUESTION_DISPLAY_IMAGE_ERROR";

export interface UploadOlympicQuestionDisplayImageAction {
  type: typeof UPLOAD_OLYMPIC_QUESTION_DISPLAY_IMAGE;
  payload: {
    file: File;
    history: History;
    questionId?: string;
  };
}
export interface UploadOlympicQuestionDisplayImageSuccessAction {
  type: typeof UPLOAD_OLYMPIC_QUESTION_DISPLAY_IMAGE_SUCCESS;
  payload: MediaDto;
}

export interface UploadOlympicQuestionDisplayImageErrorAction {
  type: typeof UPLOAD_OLYMPIC_QUESTION_DISPLAY_IMAGE_ERROR;
  payload: any;
}
//#endregion

//#region Add Edit Olympic Question modal
export const TOGGLE_ADD_EDIT_OLYMPIC_QUESTION_MODAL: any =
  "TOGGLE_ADD_EDIT_OLYMPIC_QUESTION_MODAL";

export interface ToggleAddEditOlympicQuestionModalAction {
  type: typeof TOGGLE_ADD_EDIT_OLYMPIC_QUESTION_MODAL;
  payload: any;
}
//#endregion

//#region Add Update Olympic

export const ADD_UPDATE_OLYMPIC = "ADD_UPDATE_OLYMPIC";
export const ADD_UPDATE_OLYMPIC_SUCCESS: any = "ADD_UPDATE_OLYMPIC_SUCCESS";
export const ADD_UPDATE_OLYMPIC_ERROR: any = "ADD_UPDATE_OLYMPIC_ERROR";

export interface AddUpdateOlympicAction {
  type: typeof ADD_UPDATE_OLYMPIC;
  payload: {
    request: CreateUpdateOlympicRequest;
    history: History;
  };
}

export interface AddUpdateOlympicSuccessAction {
  type: typeof ADD_UPDATE_OLYMPIC_SUCCESS;
  payload: null;
}

export interface AddUpdateOlympicErrorAction {
  type: typeof ADD_UPDATE_OLYMPIC_ERROR;
  payload: any;
}
//#endregion

//#region Get Olympic By Id

export const GET_OLYMPIC = "GET_OLYMPIC";
export const GET_OLYMPIC_SUCCESS: any = "GET_OLYMPIC_SUCCESS";
export const GET_OLYMPIC_ERROR: any = "GET_OLYMPIC_ERROR";

export interface GetOlympicAction {
  type: typeof GET_OLYMPIC;
  payload: {
    id: string;
    history: History;
  };
}

export interface GetOlympicSuccessAction {
  type: typeof GET_OLYMPIC_SUCCESS;
  payload: OlympicQuestionDto;
}

export interface GetOlympicErrorAction {
  type: typeof GET_OLYMPIC_ERROR;
  payload: any;
}
//#endregion

//#region Get Olympics

export const GET_OLYMPICS = "GET_OLYMPICS";
export const GET_OLYMPICS_SUCCESS: any = "GET_OLYMPICS_SUCCESS";
export const GET_OLYMPICS_ERROR: any = "GET_OLYMPICS_ERROR";

export interface GetOlympicsAction {
  type: typeof GET_OLYMPICS;
  payload: { query: PaginateQuery };
}

export interface GetOlympicsSuccessAction {
  type: typeof GET_OLYMPICS_SUCCESS;
  payload: Paginated<OlympicDto>;
}

export interface GetOlympicsErrorAction {
  type: typeof GET_OLYMPICS_ERROR;
  payload: any;
}

//#endregion

//#region Delete Olympic

export const DELETE_OLYMPIC_CONSENT: any = "DELETE_OLYMPIC_CONSENT";
export const DELETE_OLYMPIC = "DELETE_OLYMPIC";
export const DELETE_OLYMPIC_SUCCESS: any = "DELETE_OLYMPIC_SUCCESS";
export const DELETE_OLYMPIC_ERROR: any = "DELETE_OLYMPIC_ERROR";

export interface DeleteOlympicConsentAction {
  type: typeof DELETE_OLYMPIC_CONSENT;
  payload: string;
}

export interface DeleteOlympicAction {
  type: typeof DELETE_OLYMPIC;
  payload: {
    id: string;
  };
}

export interface DeleteOlympicSuccessAction {
  type: typeof DELETE_OLYMPIC_SUCCESS;
  payload: null;
}

export interface DeleteOlympicErrorAction {
  type: typeof DELETE_OLYMPIC_ERROR;
  payload: any;
}
//#endregion

//#region Get Olympic Participant

export const GET_OLYMPIC_PARTICIPANTS = "GET_OLYMPIC_PARTICIPANTS";
export const GET_OLYMPIC_PARTICIPANTS_SUCCESS: any =
  "GET_OLYMPIC_PARTICIPANTS_SUCCESS";
export const GET_OLYMPIC_PARTICIPANTS_ERROR: any =
  "GET_OLYMPIC_PARTICIPANTS_ERROR";

export interface GetOlympicParticipantsAction {
  type: typeof GET_OLYMPIC_PARTICIPANTS;
  payload: {
    request: PaginateQuery;
    history: History;
  };
}

export interface GetOlympicParticipantsSuccessAction {
  type: typeof GET_OLYMPIC_PARTICIPANTS_SUCCESS;
  payload: Paginated<OlympicParticipantDto>;
}

export interface GetOlympicParticipantsErrorAction {
  type: typeof GET_OLYMPIC_PARTICIPANTS_ERROR;
  payload: any;
}
//#endregion

// Export a union type that represents all possible actions
export type ActionTypes =
  | GetQuestionsByOlympicAction
  | GetQuestionsByOlympicSuccessAction
  | GetQuestionsByOlympicErrorAction
  | GetOlympicQuestionAction
  | GetOlympicQuestionSuccessAction
  | GetOlympicQuestionErrorAction
  | AddOlympicQuestionAction
  | AddOlympicQuestionSuccessAction
  | AddOlympicQuestionErrorAction
  | UpdateOlympicQuestionAction
  | UpdateOlympicQuestionSuccessAction
  | UpdateOlympicQuestionErrorAction
  | DeleteOlympicQuestionAction
  | DeleteOlympicQuestionSuccessAction
  | DeleteOlympicQuestionErrorAction
  | UploadOlympicQuestionDisplayImageAction
  | UploadOlympicQuestionDisplayImageSuccessAction
  | UploadOlympicQuestionDisplayImageErrorAction
  | ToggleAddEditOlympicQuestionModalAction
  | AddUpdateOlympicAction
  | AddUpdateOlympicSuccessAction
  | AddUpdateOlympicErrorAction
  | GetOlympicAction
  | GetOlympicSuccessAction
  | GetOlympicErrorAction
  | GetOlympicsAction
  | GetOlympicsSuccessAction
  | GetOlympicsErrorAction
  | DeleteOlympicAction
  | DeleteOlympicSuccessAction
  | DeleteOlympicErrorAction
  | GetOlympicParticipantsAction
  | GetOlympicParticipantsSuccessAction
  | GetQuestionsByOlympicErrorAction;
